import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { connect } from 'react-redux';
import SubscriptionForm from '../SubscriptionForm';
import SubscriptionAudit from '../SubscriptionAudit/SubscriptionAudit';

export class DialogContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: "details"
        };
    }


    componentDidMount() {

    }

    changeView = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{ width: '100%' }}>
                    <div className="col-md-2">
                        <ul className="subSideNav">
                            <li onClick={() => this.changeView("details")} className={this.state.view === "details" ? "active" : ""} >Subscription Details</li>
                            <li onClick={() => this.changeView("audit")} className={this.state.view === "add" ? "active" : ""}>Audit History</li>
                        </ul>
                    </div>
                    <div className="col-md-10">
                        {this.state.view === "details" ?
                            <SubscriptionForm
                                dataItem={this.props.dataItem}
                                save={this.props.save}
                                new={this.props.new}
                                cancel={this.props.cancel}
                                add={this.props.add}
                                modify={this.props.modify}
                            />
                            : ""}
                        {this.state.view === "audit" ?
                            <SubscriptionAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                            : ""}
                    </div>
                </div>
            </div>
        );
    }
}

export default DialogContainer;
